import type { Styles } from '@adornis/ass/style.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import type { ColorType } from '@adornis/chemistry/elements/theming/coloring-system.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './tr-icon.js';

@customElement('tr-button-small')
export class TRButtonSmall extends ChemistryLitElement {
  @property({ attribute: 'icon' }) icon!: string;
  @property() action!: (e: MouseEvent) => any;
  @property({ attribute: false }) color: ColorType = this.colors.accent;
  @property({ attribute: 'mode' }) mode: 'outline' | 'fill' = 'fill';
  @property({ attribute: 'not-clickable', type: Boolean }) notClickable = false;

  override render() {
    return html`
      <tr-flex class="container" padding="xs" horizontal space="sm" crossaxis-center center @click=${this.action} h100>
        ${this.icon ? html` <tr-icon> ${this.icon} </tr-icon> ` : nothing}
        <slot></slot>
      </tr-flex>
    `;
  }

  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        '.container': {
          ...(this.mode === 'fill'
            ? { background: this.color, color: '#fff' }
            : { border: `1px solid ${this.color}`, color: this.color }),
          borderRadius: this.sizes.borderRadius,
        },
        '.container:hover': this.notClickable
          ? {
              userSelect: 'none',
            }
          : {
              background: this.color.shade(300),
              ...(this.mode === 'outline' ? { color: '#fff' } : {}),
              cursor: 'pointer',
            },
      },
    ];
  }
}
